import { DomSanitizer } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';
import DOMPurify from 'dompurify';

@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value): any {
    
    // MRD - add hook to DOMPurify such that all elements that can function as a link will open the linked page in a new tab or window
    DOMPurify.addHook('afterSanitizeAttributes', function (node) {
      // set all elements owning target to target=_blank
      if ('target' in node) {
        node.setAttribute('target', '_blank');
      }
      // set non-HTML/MathML links to xlink:show=new
      if (
        !node.hasAttribute('target') &&
        (node.hasAttribute('xlink:href') || node.hasAttribute('href'))
      ) {
        node.setAttribute('xlink:show', 'new');
      }
    });

    // sanitize content
    const sanitizedContent = DOMPurify.sanitize(value);

    // tidy up and remove hook
    DOMPurify.removeHook('afterSanitizeAttributes');

    // return sanitized content
    return this.sanitized ? this.sanitized.bypassSecurityTrustHtml(sanitizedContent) : sanitizedContent;

  }
}
